/** Max task title length — matches API validation; ~2 lines in list UI. */
export const TODO_TASK_TITLE_MAX_LENGTH = 100;
